import { useParams } from 'react-router-dom';
import { Buffer } from 'buffer';

import { OnSiteParams } from './onsite.types';

export const useOnSiteParams = (): OnSiteParams | null => {
  const { data } = useParams();
  return extractData(data);
};

const extractData = (data?: string): OnSiteParams | null => {
  if (!data) return null;

  const decodedData = Buffer.from(data, 'base64').toString();
  const parsedData = JSON.parse(decodedData);
  return parsedData as OnSiteParams;
};
